import React from 'react';
import { FilePlusIcon, FileTextIcon, Link2Icon, PlusIcon } from '@radix-ui/react-icons';

import { DropdownMenu } from '../../../components/modals/dropdown-menu/DropdownMenu';
import { selectFiles } from '../../../core/services/file.service';

import styles from './add-asset-button.module.scss';
type FilterButtonProps = {
  onSelectFile: (files: File[]) => Promise<void>;
  onSelectLink: (event: Event) => void;
  onSelectNote: (event: Event) => void;
  onCreateFolder: (event: Event) => void;
};

export const AddAssetButton: React.FC<FilterButtonProps> = ({
  onSelectFile,
  onSelectLink,
  onSelectNote,
  onCreateFolder,
}) => {
  const items: React.ComponentProps<typeof DropdownMenu>['items'] = [
    {
      title: 'Add file',
      icon: <PlusIcon />,
      onSelect: async () => {
        const files = await selectFiles({ multiple: true });

        if (files) {
          onSelectFile(files);
        }
      },
    },
    { title: 'Add link', icon: <Link2Icon />, onSelect: onSelectLink },
    { title: 'Add note', icon: <FileTextIcon />, onSelect: onSelectNote },
    { title: 'Create folder', icon: <FilePlusIcon />, onSelect: onCreateFolder },
  ];

  return (
    <DropdownMenu
      items={items}
      size="free-size"
      side={'top'}
      trigger={
        <button className={styles['button']}>
          <PlusIcon />
        </button>
      }
    />
  );
};
